import React from "react";
import { observer, inject } from "mobx-react";
import { SubaruOffer } from "../models/HomePageModel";

interface FindAnOfferProps {
  subaruOffer: SubaruOffer;
}

const SubaruOffers: React.FC<FindAnOfferProps> = ({ subaruOffer }) => {
  return (
    <section className="pageHero find_an_offer dark-bg">
      {/* if someone complains about dark/dull image please add this line to all the backgroundimage divs
      <div className="fullBgImage__overlay"></div> */}
      <div
        className="fullBgImage hidden-lg hidden-sm hidden-md"
        style={{ backgroundImage: "url(" + subaruOffer.xsImageUrl + ")" }}
      >
        {/* for reference for dull/dark uncomment this line
                <div className="fullBgImage__overlay"></div> */}
      </div>

      <div
        className="fullBgImage hidden-lg hidden-xs hidden-md"
        style={{ backgroundImage: "url(" + subaruOffer.smImageUrl + ")" }}
      />

      <div
        className="fullBgImage hidden-lg hidden-xs hidden-sm"
        style={{ backgroundImage: "url(" + subaruOffer.lgImageUrl + ")" }}
      />

      <div
        className="fullBgImage hidden-md hidden-sm hidden-xs"
        style={{ backgroundImage: "url(" + subaruOffer.xlImageUrl + ")" }}
      />

      <div className="pageHero__content container">
        <div className="row">
          <div className="col-xs-12">
            {subaruOffer.ctaTitle && (
              <h2 className="text-uppercase text-center">
                {subaruOffer.ctaTitle}
              </h2>
            )}
            {subaruOffer.ctaTitle && <hr className="short-round-line"></hr>}
            {subaruOffer.ctaDescription && <p>{subaruOffer.ctaDescription}</p>}
          </div>
        </div>
        {subaruOffer.linkTitle !== "" && (
          <div className="offers-link text-center">
            <a href={subaruOffer.link} className="btn">
              {subaruOffer.linkTitle}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default inject("homePageStore")(observer(SubaruOffers));
